module.exports = __webpack_public_path__ + "static/media/Ico-6.37e3c25f.png";